var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:[
		'btn',
		("btn--" + _vm.color),
		("btn--" + _vm.size),
		{ full: _vm.full },
		{ loading: _vm.loading },
		{ disabled: _vm.disabled },
		_vm.tooltip ? 'btn--tooltip' : '',
		_vm.bg ? ("btn--bg-" + _vm.bg) : ''
	],attrs:{"type":_vm.submit ? 'submit' : 'button'}},[(_vm.tooltip)?_c('span',{staticClass:"btn__tooltip"},[_vm._v(_vm._s(_vm.tooltip))]):_vm._e(),(!_vm.loading)?_vm._t("default"):_vm._e(),(_vm.loading)?_c('Loading'):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }